export enum ProfileApprovalStatus {
  OP = 1,
  BR = 2,
  FP = 3,
  FR = 4,
  O = 5,
  R = 6,
}

export const ProfileApprovalStatusText: Record<ProfileApprovalStatus, string> =
  {
    [ProfileApprovalStatus.OP]: "Onboarding Pending",
    [ProfileApprovalStatus.BR]: "Blitz In Review",
    [ProfileApprovalStatus.FP]: "Full Onboarding Pending",
    [ProfileApprovalStatus.FR]: "Full Onboarding In Review",
    [ProfileApprovalStatus.O]: "Onboarded",
    [ProfileApprovalStatus.R]: "Rejected",
  };

export const getStatusStyle = (
  status: ProfileApprovalStatus,
): { bgColor: string; textColor: string } => {
  switch (status) {
    case ProfileApprovalStatus.O:
      return { bgColor: "tw-bg-[#ECFDF3]", textColor: "tw-text-[#027A48]" };
    case ProfileApprovalStatus.R:
      return { bgColor: "tw-bg-[#FEF3F2]", textColor: "tw-text-[#B42318]" };
    default:
      return { bgColor: "tw-bg-[#F5F5F5]", textColor: "tw-text-[#414651]" };
  }
};
